import isString from 'vegas-js-core/src/isString'
import ucFirst  from 'vegas-js-core/src/strings/ucFirst'

import Form from '../../../../display/forms/FormElements'

import Livestock    from '../../../../things/Livestock'
import Veterinarian from '../../../../things/Veterinarian'
import Thing        from '../../../../things/Thing'

import api from '../../../../configs/api'

const elements =
[
    {
        type       : Form.SEARCH_SELECTOR ,
        clazz      : Veterinarian ,
        path       : api.veterinarians.url ,
        clearable  : false ,
        closeLabel : 'Fermer' ,
        init       :
        {
            id              : 'veterinarian',
            key             : 'veterinarian',
            autoComplete    : 'off' ,
            label           : 'Vétérinaire',
            autoFocus       : true,
            fullWidth       : true,
            helperText      : 'Obligatoire',
            margin          : 'normal',
            required        : true,
            select          : false,
            type            : 'search',
            variant         : 'outlined'
        },
        inputProps :
        {
            label : 'Sélectionner un vétérinaire...'
        },
        logics :
        {
            disabledSuggestions : ( props ) =>
            {
                const { rel } = props ;
                if( rel )
                {
                    const { subjectOf } = rel ;
                    if( subjectOf instanceof Livestock)
                    {
                        const { veterinarians } = subjectOf;
                        return veterinarians ;
                    }
                }
                return null ;
            }
        },
        suggestionRef : ( item ) =>
        {
            if( item instanceof Veterinarian )
            {
                const { authority } = item ;
                if( authority instanceof Thing )
                {
                    return authority ;
                }
            }
            return item ;
        },
        valueLabel : ( item , props ) =>
        {
            if( item instanceof Veterinarian )
            {
                const { authority } = item ;
                if( authority instanceof Thing )
                {
                    return ucFirst(authority.getLocaleName(props.lang)) ;
                }
            }
            return item ;
        }
    }
];

const prepare = ( item ) =>
{
    if( item )
    {
        const { veterinarian } = item ;
        return { veterinarian } ;
    }
    return null ;
};

const mapUri = ( item , uri ) =>
{
    if( item )
    {
        const { veterinarian } = item ;
        if( veterinarian instanceof Veterinarian )
        {
            return uri + '/' + veterinarian.id ;
        }
    }
    return uri ;
};

const veterinarians =
{
    add :
    {
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        title       : 'Ajouter un vétérinaire' ,
        description : 'Veuillez sélectionner un vétérinaire ci-dessous.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en  cours...' ,
        success     : 'Ajout du nouveau vétérinaire réussi!' ,
        elements,
        prepare,
        mapUri,
    },
    cell :
    {
        identifier : 'N° Ordinal:',
        unknow     : 'Iconnnu'
    } ,
    fail       : 'Données non trouvées...' ,
    loading    : "Chargement ..." ,
    noDataText : 'Aucun résultat' ,
    pagination :
    {
        first    : 'Première' ,
        last     : 'Dernière' ,
        next     : 'Suivante' ,
        pages    : 'Pages' ,
        previous : 'Précédente' ,
        select   : '1 vétérinaire sélectionné' ,
        selectA  : 'Sélectionner' ,
        selectX  : '{0} vétérinaires sélectionnés' ,
        title    : 'Sélectionner',
        tooltips :
        {
            remove  : 'Supprimer (1)' ,
            removeX : 'Supprimer ({0})' ,
            select  : 'Sélectionner'
        }
    },
    remove :
    {
        agree        : 'Supprimer' ,
        description  : 'Souhaitez-vous supprimer ce vétérinaire:' ,
        descriptionX : 'Souhaitez-vous supprimer les {0} vétérinaires:' ,
        disagree     : 'Annuler',
        item         :
        {
            text :
            {
                primary : ( element , props ) =>
                {
                    if( element instanceof Veterinarian )
                    {
                        const { authority } = element ;
                        if( authority instanceof Thing )
                        {
                            return authority.getLocaleName(props.lang);
                        }
                    }
                    return 'Inconnu' ;
                },
                secondary : ( element ) =>
                {
                    if( element instanceof Veterinarian )
                    {
                        const { identifier } = element ;
                        if( isString(identifier) )
                        {
                            return veterinarians.cell.identifier + " " + identifier ;
                        }
                    }
                    return null ;
                }
            }
        } ,
        loading      : 'Suppression en cours...' ,
        title        : 'Supprimer le vétérinaire ?' ,
        titleX       : 'Supprimer des vétérinaires ?'
    },
    removeAll :
    {
        agree        : 'Supprimer' ,
        description  : 'Souhaitez-vous supprimer le vétérinaire:' ,
        descriptionX : 'Souhaitez-vous supprimer les {0} vétérinaires:' ,
        disagree     : 'Annuler' ,
        loading      : 'Suppression en cours...' ,
        title        : 'Supprimer un vétérinaire ?' ,
        titleX       : 'Supprimer des vétérinaires ?'
    },
    removeItem  : "Supprimer un vétérinaire" ,
    removeItemX : "Supprimer {0} vétérinaires" ,
    search      : 'Rechercher un vétérinaire ...' ,
    title       : 'Vétérinaires' ,
    tooltips    :
    {
        add    : "Ajouter" ,
        remove : "Supprimer"
    }
};

export default veterinarians ;
